<template>
    <main>
        <div class="card shadow-none border-0">
            <div class="card-header bg-light">Exploración Física</div>
            <div class="card-body">
                <div class="form-group row" v-for="item in $v.partes_fisicas.$each.$iter" :key="item.id">
                    <label  class="col-sm-12 col-form-label font-weight-bolder"> {{item.nombre.$model}} </label>
                    <div class="col-sm-12">
                        <textarea class="form-control" v-model="item.detalle.$model" :class="{'is-invalid':item.detalle.$error}"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import partesFisicasService from "../../../../services/partesFisicasService";
import historiaExploracionFisicaService from "../../../../services/historiaExploracionFisicaService";
import historiaClinicaService from "../../../../services/historiaClinicaService";
import {isEmpty} from 'lodash';
import dayjs from "dayjs";

export default {
    props:['idHistoria','finalizada','modo','edad'],
    data(){
        return {
            partes_fisicas:[],
            todas_partes:[],
            edadCalculada: null,
        }
    },
    validations (){
        return {
            partes_fisicas:{
                $each:{
                    nombre:{required},
                    detalle:{required}
                }
            }
        }
    },
    methods:{
        retornar(){
            this.$v.$touch();

            if(this.$v.$invalid) return false;

            let exploracion ={
                id_historia:this.idHistoria,
                partes:this.partes_fisicas,
            }

            return exploracion;
        },
        async obtenerEdadPaciente() {
            if (this.edad !== null && this.edad !== undefined && this.edad !== '') {
                const parsed = parseInt(this.edad);
                if (!isNaN(parsed)) return parsed;
            }

            if (this.edadCalculada !== null) {
                return this.edadCalculada;
            }

            if (this.idHistoria) {
                try {
                    const response = await historiaClinicaService.show(this.idHistoria);
                    if (response && response.data && response.data.usuario && response.data.usuario.fecha_nacimiento) {
                        const edad = dayjs().diff(dayjs(response.data.usuario.fecha_nacimiento), 'year');
                        this.edadCalculada = edad;
                        return edad;
                    }
                } catch (e) {
                    console.error("Error al obtener edad de la historia en exploracionFisica:", e);
                }
            }

            return null;
        },
        cumpleConfiguracion(parte, edadPaciente){
            const tieneEdadInicio = parte.edad_inicio !== null && parte.edad_inicio !== undefined && parte.edad_inicio !== '';
            const tieneEdadFinal = parte.edad_final !== null && parte.edad_final !== undefined && parte.edad_final !== '';
            const tieneHistorias = parte.historias !== null && parte.historias !== undefined && String(parte.historias).trim() !== '';

            // Solo se aplica el filtro para aquellos que tengan esa configuración registrada
            if (!tieneEdadInicio && !tieneEdadFinal && !tieneHistorias) {
                return true;
            }

            // Validar historias (modo) separadas por coma si están configuradas
            if (tieneHistorias) {
                const modoActual = (this.modo || '').trim().toUpperCase();
                const historiasPermitidas = String(parte.historias)
                    .split(',')
                    .map(h => h.trim().toUpperCase())
                    .filter(h => h !== '');

                if (!modoActual || !historiasPermitidas.includes(modoActual)) {
                    return false;
                }
            }

            // Validar rango de edad si está configurado
            if (tieneEdadInicio || tieneEdadFinal) {
                if (edadPaciente === null || edadPaciente === undefined || isNaN(edadPaciente)) {
                    return false;
                }

                if (tieneEdadInicio && edadPaciente < parseInt(parte.edad_inicio)) {
                    return false;
                }

                if (tieneEdadFinal && edadPaciente > parseInt(parte.edad_final)) {
                    return false;
                }
            }

            return true;
        },
        async cargarPartesFisicas(){
            const edadPaciente = await this.obtenerEdadPaciente();

            if (!this.todas_partes || this.todas_partes.length === 0) {
                const response = await partesFisicasService.index();
                this.todas_partes = response.data || [];
            }

            const partesFiltradas = this.todas_partes.filter(x => this.cumpleConfiguracion(x, edadPaciente));

            this.partes_fisicas = partesFiltradas.map(x => {
                const existente = this.partes_fisicas.find(p => parseInt(p.id) === parseInt(x.id));
                return {
                    ...x,
                    detalle: existente ? existente.detalle : (x.defaultText || '')
                };
            });
        },
        async cargarDatos(){
            await this.cargarPartesFisicas();
            if(this.finalizada==='N' && this.idHistoria){
                const response = await historiaExploracionFisicaService.showByHc(this.idHistoria);
                if(!isEmpty(response.data)){
                    response.data.forEach(x=>{
                        let i = this.partes_fisicas.findIndex(p => parseInt(p.id) === parseInt(x.id_parte_fisica));
                        if(i!==-1) this.partes_fisicas[i].detalle = x.detalle;
                    });
                }
            }
        }
    },
    watch:{
        finalizada: async function (){
            await this.cargarDatos();
        },
        edad: async function (newVal, oldVal){
            if (newVal !== oldVal) {
                await this.cargarDatos();
            }
        },
        modo: async function (newVal, oldVal){
            if (newVal !== oldVal) {
                await this.cargarDatos();
            }
        }
    },
    async created(){
        await this.cargarDatos();
    }
}
</script>